export const useStyles = theme => ({
  pageHeader: {
    marginBottom: theme.spacing(5)
  },
  form: {
    marginTop: theme.spacing(3),
    boxShadow: 'none',   
  },
  formCardContent: {
    padding: 0
  },
  cardAction: {
    marginTop: 100,
    marginBottom: 45,
    padding: 0
  },
  requiredAsterisk: {
    color: 'red',
  },
  labelCss: {
    fontSize: 15, 
    top: '-5px',
    fontWeight: 'bold'
  },
  buttonProgress: {
    verticalAlign: 'middle',
    marginLeft: theme.spacing(1),
  },
  addButton: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontWeight: 'bold'
  },
  wrapper: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  addWrapper: {
    padding: '0 24px',
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }    
  },
  answersGroup: {
    flexDirection: 'row',
    width: '100%',
  },
  queHeaderWrapper: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  tieBrakerQue: {
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  iconMargin: {
    marginLeft: theme.spacing(1),
  },
  backButton: {
    marginRight: theme.spacing(2),
    marginLeft: 'auto',
    width: 180
  },
  submitButton: {
    marginLeft: 'auto',
    fontWeight: 'bold'
  },
  marginBottom10: {
    marginBottom: '8px'
  },
  cardActionBtn: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      '& button': {        
        width: '100%',
        marginBottom: 20
      }
    }
  },
  '@global': {
    [theme.breakpoints.down('sm')]: {
      '.MuiTabs-flexContainer': {
        display: 'block',
       
      },
      '.MuiTabs-scroller.MuiTabs-fixed': {
        whiteSpace: 'normal'
      },
      '.MuiTabs-flexContainer .MuiTab-fullWidth': {
        width: '100%'
      },
      '.MuiTabs-flexContainer .MuiTab-fullWidth.Mui-selected': {
        borderBottom: '2px solid #009F3C'
      },
      '.MuiTabs-indicator': {
        display: 'none'
      }
    },
    '.MuiFormControlLabel-label': {
      fontWeight: 'bold'
    }
  },
  memberContainer: {
    border: "solid 1px silver",
    cursor: "pointer",
    display: "block",
    padding: "6px",
    marginTop: "10px",
    textAlign: "center",
    marginRight: "20px",
    borderRadius: "8px",
    paddingRight: "20px",
    padding: "6px 16px",
    fontSize: "14px",
    minWidth: "64px",
    boxSizing: "border-box",
    transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontWeight: "bold",
    lineHeight: "1.75",
    borderRadius: "4px",
    textTransform: "uppercase"
  },
  });
  